import {styled} from '@mui/material/styles';

export const LoaderWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center'
});
